<template>
  <div class="configuration">
    <div class="main_config__wrap">
      <div class="main_config">
        <div class="tabs">
          <span
            class="tab"
            :class="{ active: block === 'LAN' }"
            @click="selected_block('LAN')"
          >
            LAN
          </span>
          <span
            class="tab"
            :class="{ active: block === 'WAN' }"
            @click="selected_block('WAN')"
            >WAN</span
          >
          <span
            class="tab"
            :class="{ active: block === 'Wifi' }"
            @click="selected_block('Wifi')"
            >Wi-Fi</span
          >
          <span
            class="tab"
            :class="{ active: block === 'Modems' }"
            @click="selected_block('Modems')"
            >{{ translate("device.config_dashboard.modems.modems") }}</span
          >
        </div>
        <div class="block">
          <div v-if="block === 'LAN'">
            <span
              class="add_lan btn btn-success button_add"
              @click.prevent="addNewNetwork"
            >
              {{ translate("device.config_dashboard.butn.add_new_network") }}
            </span>
            <div class="page">
              <ConfigurationLAN
                v-for="(lan, index) in newJson.network"
                :key="index"
                :dataLan="lan"
                :header="index"
                :optionsPorts="optionsPorts"
                :optionsWAN="optionsWAN"
                :listWanTunnels="listWanTunnels"

                @delete="deleteLan"
                @update="updateLan"
              />
            </div>
          </div>
          <div v-if="block === 'WAN'">
            <div class="add_lan button_add">
              <span
                class="btn btn-success"
                style="font-size: 13px; margin-right: 20px"
                @click="addNewSuperTcp"
              >
                {{
                  translate("device.config_dashboard.butn.add_new_super_tcp")
                }}
              </span>
            </div>
            <div class="page">
              <ConfigurationWAN
                v-for="(superTcp, index) in newSuperTcp"
                :key="index"
                :header="index"
                :dataSuperTcp="superTcp"
                :optionsWAN="optionsWAN"
                @delete="deleteWanSuperTcp"
                @update="updateSuperTcp"
              />
            </div>
            <div class="add_lan button_add">
              <span
                class="btn btn-success"
                style="font-size: 13px"
                @click="addNewRouteMan"
              >
                {{
                  translate("device.config_dashboard.butn.add_new_route_man")
                }}
              </span>
            </div>
            <div class="page">
              <ConfigurationWANrouteMan
                v-for="(routeMan, index) in newRouteMan"
                :key="index"
                :header="index"
                :dataRouteMan="routeMan"
                :optionsWAN="optionsWAN"
                @delete="deleteWanRouteMan"
                @update="updateRouteMan"
              />
            </div>
          </div>
          <div v-if="block === 'Wifi'">
            <div class="add_lan button_add">
              <span
                class="btn btn-success"
                style="font-size: 13px; margin-right: 20px"
                @click="addNewWifiClient"
              >
                {{
                  translate("device.config_dashboard.butn.add_new_wifi_client")
                }}
              </span>
            </div>
            <div class="page">
              <ConfigurationWifi
                v-for="(wifiClient, index) in newWifiClient"
                :key="index"
                :header="index"
                :dataWifiClient="wifiClient"
                @delete="deleteWifiClient"
                @update="updateWifiClient"
              />
            </div>
            <div class="add_lan button_add">
              <span
                class="btn btn-success"
                style="font-size: 13px"
                @click="addNewWifiAp"
              >
                {{ translate("device.config_dashboard.butn.add_new_wifi_ap") }}
              </span>
            </div>
            <div class="page">
              <ConfigurationWifiAp
                v-for="(wifiAp, index) in newWifiAp"
                :key="index"
                :header="index"
                :dataWifiAp="wifiAp"
                :lanIfaces="lanIfacesForWifi"
                @delete="deleteWifiAp"
                @update="updateWifiAp"
              />
            </div>
          </div>
          <div v-if="block === 'Modems'">
            <!-- <div class="add_lan button_add">
              <span
                class="btn btn-success"
                style="font-size: 13px"
                @click.prevent="addNewModem"
              >
                {{ translate("device.config_dashboard.butn.add_new_modem") }}
              </span>
            </div> -->
            <div class="page">
              <ConfigurationModems
                v-for="(modem, index) in newModems"
                :key="index"
                :header="index"
                :dataModem="modem"
                :listWanTunnels="listWanTunnels"
                @update="updateModems"
              />
            </div>
          </div>
        </div>
        <div class="button">
          <span v-if="!check_save" @click="pre_save" class="btn btn-success">
            {{ translate('btn.compare_save') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigurationLAN from "./Tabs/LAN/LAN.vue";
import ConfigurationWAN from "./Tabs/WAN/WAN.vue";
import ConfigurationWANrouteMan from "./Tabs/WAN/WANrouteMan.vue";
import ConfigurationModems from "./Tabs/Modems/Modems.vue";
import ConfigurationWifi from "./Tabs/Wifi/Wi-fi_client.vue";
import ConfigurationWifiAp from "./Tabs/Wifi/Wi-fi_ap.vue";
import ipSubnetCalculator from "ip-subnet-calculator";
import CompareConfigs2 from "./CompareConfigs2.vue";

export default {
  name: "Configuration2",
  components: {
    ConfigurationLAN,
    ConfigurationWAN,
    ConfigurationWANrouteMan,
    ConfigurationModems,
    ConfigurationWifi,
    ConfigurationWifiAp,
    ipSubnetCalculator,
  },
  props: {
    dev_fid: [String],
    dev_id: [Number, String],
    interfaces: [Object],
    version: [Array],
  },
  data() {
    return {
      original_config: {},
      this_version: null,
      newLan: "br",
      valuesWanInterfaces: [],
      wanTunnelsModems: [],
      optionsWAN: [],
      optionsPorts: [],
      selectedLanWanInterfaces: {},
      show: false,
      ts: 0,
      ver: 0,
      main: "",
      multi: {},
      config_profile: {},
      device_config: {},
      block: "LAN",
      newJson: {
        //network: {},
      },
      newJsonForSave: {},
      newRouteMan: {},
      newSuperTcp: {},
      newWifiClient: {},
      newWifiAp: {},
      newModems: {},
      lanIfacesForWifi: [],
      forNewWifiClientWan: [],
      nameForWifi: [],
      listWanTunnels: [],
      versionHW: "",
      modemSpecialSettings: {},
    };
  },

  computed: {
    cnt_mul() {
      return 0;
    },
    check_save() {
      let original_config = JSON.stringify(this.original_config);
      let new_config = JSON.stringify(this.newJson);
      return original_config === new_config;
      }
  },
  watch: {
    $route() {
      this.to_zero();
    },
    dev_id() {
      this.show = false;
      this.load_conf();
    },
    newWifiClient:{
      deep: true,
      handler(){
        this.interfacesForWifiClients()
        Object.keys(this.newWifiClient).forEach((item) => {
          if (this.interfaces.wifis?.indexOf(item) == -1){
            this.interfaces.wifis?.push(item)
          }
        })
      }
    }
  },
  mounted() {
    this.to_zero();
  },
  methods: {
    compare_config(current_ver, last_ver){
      var t = this.$createElement(CompareConfigs2, {
        props: {
          dev_id: this.dev_id,
          current_ver,
          last_ver
        },
        on: {
          close: () => {
            this.$modal.hide('compare_configs2_modal')
          },
          save: () => {
            this.save(false)
            this.$modal.hide('compare_configs2_modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            height: 'auto',
            width: 800,
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'compare_configs2_modal'
          }
          )
    },
    pre_save(){
      this.saveCheckEmpty(this.newJson);
      //console.log({...this.newJson});
      this.save(true)
    },
    save(not_apply) {
      this.$http.v1.saveUIDeviceConfig(this.dev_fid, {not_apply: not_apply, fid: this.dev_fid, config: JSON.stringify(this.newJson)}, (response) => {
        if (not_apply){
          this.compare_config(response.data.current_ver, response.data.last_ver)
          this.forLanNetwork();
          this.forRouteMan();
          this.forSuperTcp();
          this.forWifiClient();
          this.forWifiAp();
          this.forModems();
          this.getAPN();
          this.interfacesForWifiClients();
        }else{
          this.global_notify('info', this.translate('config.saved_success'))
          this.$set(this, "original_config", {...response.data.config.main});

          this.$set(this, "newJson", response.data.config.main);

          this.forLanNetwork();
          this.forRouteMan();
          this.forSuperTcp();
          this.forWifiClient();
          this.forWifiAp();
          this.forModems();
          this.getAPN();
          this.interfacesForWifiClients();
        }
        // console.log(response);
      })
    },
    saveCheckEmpty(object){
      let myArray = ["apn", "old_apn", "dhcp", "wanTunnels", "lan_wan"];
      Object.keys(object).forEach((key) => {
        if(myArray.indexOf(key) > -1){
          delete object[key];
        }

        if (object[key] instanceof Array){
          object[key] = object[key].join()
        }

        if (typeof(object[key]) == "string") {
          if (object[key] === "") {
            delete object[key];
          }
        } else if (typeof(object[key]) == "object") {
          this.saveCheckEmpty(object[key])
          if (Object.keys(object[key]).length == 0) {
            delete object[key];
          }
        }
      })
    },
    search_double_dot(string) {
      let count_dotter = string.indexOf("..");
      let name = string.substring(0, count_dotter - 1);
      let number1 = string.substring(count_dotter - 1, count_dotter);
      let number2 = string.substring(count_dotter + 2, count_dotter + 3);
      let array = [];
      for (let i = number1; i <= number2; i++) {
        array.push("" + name + i + "");
      }
      return array;
    },
    updateLan(data) {
      //console.log(data);
      let dataKey = Object.keys(data);
      for (let i in this.newJson.network) {
        if (i == dataKey || (i !== dataKey && i == data[dataKey].old_name)) {
          delete data[dataKey].old_name
          delete this.newJson.network[i];
          this.newJson.network[dataKey] = data[dataKey];
        }
        if (data[dataKey].dhcp) {
          let dnsKey = Object.keys(this.newJson.dnsmasq);
          for (let i of dataKey) {
            dnsKey.forEach((item) => {
              if (item == i) {
                delete this.newJson.dnsmasq[item];
                this.newJson.dnsmasq[i] = data[i].dhcp;
              } else if (item !== i) {
                this.newJson.dnsmasq[i] = data[i].dhcp;
                this.newJson.dnsmasq.interface.push(i);
              }
            })
          }
        }
      }
      this.newJson.dnsmasq.interface = [...new Set(this.newJson.dnsmasq.interface)];
      // добавление интефейса в super_tcp при одном stcp
      if (this.newJson.super_tcp && !this.newJson.super_tcp.instance) {
        Object.keys(data).forEach((network_index) => {
          if (data[network_index].lan_wan?.indexOf(this.newSuperTcp.super_tcp.virt_if) > -1) {
            if (this.newSuperTcp.super_tcp.iface.indexOf(network_index) == -1) {
              this.newSuperTcp.super_tcp.iface.push(network_index);
            }
          }
        }) // добавление интефейса в super_tcp при нескольких stcp
      } else if (this.newJson.super_tcp) {
        Object.keys(data).forEach((network_index) => {
          for (let st in this.newSuperTcp) {
            if (data[network_index].lan_wan?.indexOf(this.newSuperTcp[st].virt_if) > -1) {
              if (this.newSuperTcp[st].iface.indexOf(network_index) == -1) {
              this.newSuperTcp[st].iface.push(network_index);
              }
            }
          }
        })
      } // удаление интерфейса из super_tcp при одном stcp
      if (this.newJson.super_tcp && !this.newJson.super_tcp.instance) {
        Object.keys(data).forEach((network_index) => {
          if (data[network_index].lan_wan?.indexOf(this.newSuperTcp.super_tcp.virt_if) == -1) {
            if (this.newSuperTcp.super_tcp.iface.indexOf(network_index) > -1) {
              this.newSuperTcp.super_tcp.iface = this.newSuperTcp.super_tcp.iface.filter((item) =>{
                if (item != network_index) return item
              })
            }
          }
        }) // удаление интерфейса из super_tcp при нескольких stcp
      } else if (this.newJson.super_tcp) {
        Object.keys(data).forEach((network_index) => {
          for (let st in this.newSuperTcp) {
            if (data[network_index].lan_wan?.indexOf(this.newSuperTcp[st].virt_if) == -1) {
              if (this.newSuperTcp[st].iface.indexOf(network_index) > -1) {
                this.newSuperTcp[st].iface = this.newSuperTcp[st].iface.filter((item) =>{
                  if (item != network_index) return item
                })
              }
            }
          }
        })
      }
      // добавление интефейса в route_man при одном route_man
      if (this.newJson.route_man && !this.newJson.route_man.instance) {
        Object.keys(data).forEach((network_index) => {
          if (data[network_index].lan_wan?.indexOf(this.newRouteMan.route_man.tap) > -1) {
            if (this.newRouteMan.route_man.multi_iface.indexOf(network_index) == -1) {
              this.newRouteMan.route_man.multi_iface.push(network_index);
            }
          }
        }) // добавление интефейса в route_man при нескольких route_man
      } else if (this.newJson.route_man) {
        Object.keys(data).forEach((network_index) => {
          for (let rm in this.newRouteMan) {
            if (data[network_index].lan_wan?.indexOf(this.newRouteMan[rm].tap) > -1) {
              if (this.newRouteMan[rm].multi_iface.indexOf(network_index) == -1) {
              this.newRouteMan[rm].multi_iface.push(network_index);
              }
            }
          }
        })
      } // удаление интерфейса из route_man при одном route_man
      if (this.newJson.route_man && !this.newJson.route_man.instance) {
        Object.keys(data).forEach((network_index) => {
          if (data[network_index].lan_wan?.indexOf(this.newRouteMan.route_man.tap) == -1) {
            if (this.newRouteMan.route_man.multi_iface.indexOf(network_index) > -1) {
              this.newRouteMan.route_man.multi_iface = this.newRouteMan.route_man.multi_iface.filter((item) =>{
                if (item != network_index) return item
              })
            }
          }
        }) // удаление интерфейса из route_man при нескольких route_man
      } else if (this.newJson.route_man) {
        Object.keys(data).forEach((network_index) => {
          for (let rm in this.newRouteMan) {
            if (data[network_index].lan_wan?.indexOf(this.newRouteMan[rm].tap) == -1) {
              if (this.newRouteMan[rm].multi_iface.indexOf(network_index) > -1) {
                this.newRouteMan[rm].multi_iface = this.newRouteMan[rm].multi_iface.filter((item) =>{
                  if (item != network_index) return item
                })
              }
            }
          }
        })
      }
      this.forLanNetwork();
      //console.log(this.newJson)
    },
    updateRouteMan(data) {
      //console.log(data);
      let dataKey = Object.keys(data);
      for (let i in this.newJson) {
        if (i == dataKey) {
          delete this.newJson[dataKey];
          this.newJson[dataKey] = data[dataKey];
        }
      }
      this.forRouteMan();
      // удаление интерфейса из модемД при одном роутмэне
      if (!this.newJson.route_man.instance) {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          if (this.newRouteMan.route_man.multi_iface.indexOf(modem_index.toLowerCase()) == -1 &&
          this.newRouteMan.route_man.multi_iface.indexOf("usb_" + modem_index.toLowerCase()) == -1 &&
          modem_index !== "modems" && modem_index !== "logger"){
            this.newJson.modemd[modem_index].wanTunnels = this.newJson.modemd[modem_index].wanTunnels.filter((item) =>{
              if (item != this.newRouteMan.route_man.tap) return item
            })
          }
        })
      } // удаление интерфейса из модемД при нескольких роутмэнах
      else {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          for (let rm in this.newRouteMan) {
            if (this.newRouteMan[rm].multi_iface.indexOf(modem_index.toLowerCase()) == -1 &&
            this.newRouteMan[rm].multi_iface.indexOf("usb_" + modem_index.toLowerCase()) == -1 &&
            modem_index !== "modems" && modem_index !== "logger"){
              this.newJson.modemd[modem_index].wanTunnels = this.newJson.modemd[modem_index].wanTunnels.filter((item) =>{
                if (item != this.newRouteMan[rm].tap) return item
              })
            }
          }
        })
      }
      // добавление интефейса в модемД при одном роутмэне
      if (!this.newJson.route_man.instance) {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          if ((this.newRouteMan.route_man.multi_iface.indexOf(modem_index.toLowerCase()) > -1 ||
          this.newRouteMan.route_man.multi_iface.indexOf("usb_" + modem_index.toLowerCase()) > -1) &&
          modem_index !== "modems" && modem_index !== "logger"){
            if (this.newJson.modemd[modem_index].wanTunnels.indexOf(this.newRouteMan.route_man.tap) == -1) {
              this.newJson.modemd[modem_index].wanTunnels.push(this.newRouteMan.route_man.tap)
            }
          }
        })
      } // добавление интефейса в модемД при нескольких роутмэнах
      else {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          for (let rm in this.newRouteMan) {
            if ((this.newRouteMan[rm].multi_iface.indexOf(modem_index.toLowerCase()) > -1 ||
            this.newRouteMan[rm].multi_iface.indexOf("usb_" + modem_index.toLowerCase()) > -1) &&
            modem_index !== "modems" && modem_index !== "logger"){
              if (this.newJson.modemd[modem_index].wanTunnels.indexOf(this.newRouteMan[rm].tap) == -1) {
              this.newJson.modemd[modem_index].wanTunnels.push(this.newRouteMan[rm].tap)
              }
            }
          }
        })
      }
      // удаление интерфейса из wifi client при одном роутмэне
      if (!this.newJson.route_man.instance && this.newJson.wifi_client) {
        Object.keys(this.newWifiClient).forEach((wifi_index) => {
          if (this.newRouteMan.route_man.multi_iface.indexOf(wifi_index) == -1) {
              this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces.filter((item) =>{
                if (item != this.newRouteMan.route_man.tap) return item
              })
            //}
          }
        })
      } // удаление интерфейса из wifi client при нескольких роутмэнах
      else {
        if (this.newJson.wifi_client) {
          Object.keys(this.newWifiClient).forEach((wifi_index) => {
            for (let rm in this.newRouteMan) {
              if (this.newRouteMan[rm].multi_iface.indexOf(wifi_index) == -1) {
                  this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces.filter((item) =>{
                    if (item != this.newRouteMan[rm].tap) return item
                })
                //}
              }
            }
          })
        }
      }
      // добавление интефейса в wifi client при одном роутмэне
      if (!this.newJson.route_man.instance && this.newJson.wifi_client) {
        Object.keys(this.newWifiClient).forEach((wifi_index) => {
          if (this.newRouteMan.route_man.multi_iface.indexOf(wifi_index) > -1){
              this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces ? this.newWifiClient[wifi_index].wan_ifaces : [];
              if (this.newWifiClient[wifi_index].wan_ifaces.indexOf(this.newRouteMan.route_man.tap) == -1) {
                this.newWifiClient[wifi_index].wan_ifaces.push(this.newRouteMan.route_man.tap)
              }
          }
        })
      } // добавление интефейса в wifi client при нескольких роутмэнах
      else {
        if (this.newJson.wifi_client) {
          Object.keys(this.newWifiClient).forEach((wifi_index) => {
            for (let rm in this.newRouteMan) {
              if (this.newRouteMan[rm].multi_iface.indexOf(wifi_index) > -1){
                this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces ? this.newWifiClient[wifi_index].wan_ifaces : [];
                  if (this.newWifiClient[wifi_index].wan_ifaces.indexOf(this.newRouteMan[rm].tap) == -1) {
                  this.newWifiClient[wifi_index].wan_ifaces.push(this.newRouteMan[rm].tap)
                  }
              }
            }
          })
        }
      }
      // удаление интерфейса из lan при одном роутмэне
      if (!this.newJson.route_man.instance && this.newJson.network) {
        Object.keys(this.newJson.network).forEach((network_index) => {
          if (this.newJson.network[network_index].lan_wan && this.newRouteMan.route_man.multi_iface.indexOf(network_index) == -1) {
            this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan.filter((item) =>{
                if (item != this.newRouteMan.route_man.tap) return item
              })
          }
        })
      } // удаление интерфейса из lan при нескольких роутмэнах
      else {
        if (this.newJson.network) {
          Object.keys(this.newJson.network).forEach((network_index) => {
            for (let rm in this.newRouteMan) {
              if (this.newJson.network[network_index].lan_wan && this.newRouteMan[rm].multi_iface.indexOf(network_index) == -1) {
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan.filter((item) =>{
                      if (item != this.newRouteMan[rm].tap) return item
                  })
              }
            }
          })
        }
      }
      // добавление интефейса в lan при одном роутмэне
      if (!this.newJson.route_man.instance && this.newJson.network) {
        Object.keys(this.newJson.network).forEach((network_index) => {
          if (!this.newJson.network[network_index].wan && this.newRouteMan.route_man.multi_iface.indexOf(network_index) > -1){
            this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
              if (this.newJson.network[network_index].lan_wan.indexOf(this.newRouteMan.route_man.tap) == -1) {
                this.newJson.network[network_index].lan_wan.push(this.newRouteMan.route_man.tap)
              }
          }
        })
      } // добавление интефейса в lan при нескольких роутмэнах
      else {
        if (this.newJson.network) {
          Object.keys(this.newJson.network).forEach((network_index) => {
            for (let rm in this.newRouteMan) {
              if (!this.newJson.network[network_index].wan && this.newRouteMan[rm].multi_iface.indexOf(network_index) > -1){
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
                if (this.newJson.network[network_index].lan_wan.indexOf(this.newRouteMan[rm].tap) == -1) {
                  this.newJson.network[network_index].lan_wan.push(this.newRouteMan[rm].tap)
                  }
              }
            }
          })
        }
      }
      this.forRouteMan();
      //console.log(this.newJson);
    },
    updateSuperTcp(data) {
      //console.log(data);
      let dataKey = Object.keys(data);
      for (let i in this.newJson) {
        if (i == dataKey) {
          delete this.newJson[i];
          this.newJson[dataKey] = data[dataKey];
        }
      }
      this.forSuperTcp();
      // удаление интерфейса из модемД при одном stcp
      if (!this.newJson.super_tcp.instance) {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          if (this.newSuperTcp.super_tcp.iface.indexOf(modem_index.toLowerCase()) == -1 &&
          this.newSuperTcp.super_tcp.iface.indexOf("usb_" + modem_index.toLowerCase()) == -1 &&
          modem_index !== "modems" && modem_index !== "logger"){
            this.newJson.modemd[modem_index].wanTunnels = this.newJson.modemd[modem_index].wanTunnels.filter((item) =>{
              if (item != this.newSuperTcp.super_tcp.virt_if) return item
            })
          }
        })
      } // удаление интерфейса из модемД при нескольких stcp
      else {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          for (let st in this.newSuperTcp) {
            if (this.newSuperTcp[st].iface.indexOf(modem_index.toLowerCase()) == -1 &&
            this.newSuperTcp[st].iface.indexOf("usb_" + modem_index.toLowerCase()) == -1 &&
            modem_index !== "modems" && modem_index !== "logger"){
              this.newJson.modemd[modem_index].wanTunnels = this.newJson.modemd[modem_index].wanTunnels.filter((item) =>{
                if (item != this.newSuperTcp[st].virt_if) return item
              })
            }
          }
        })
      }
      // добавление интефейса в модемД при одном stcp
      if (!this.newJson.super_tcp.instance) {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          if ((this.newSuperTcp.super_tcp.iface.indexOf(modem_index.toLowerCase()) > -1 ||
          this.newSuperTcp.super_tcp.iface.indexOf("usb_" + modem_index.toLowerCase()) > -1) &&
          modem_index !== "modems" && modem_index !== "logger"){
            if (this.newJson.modemd[modem_index].wanTunnels.indexOf(this.newSuperTcp.super_tcp.virt_if) == -1) {
              this.newJson.modemd[modem_index].wanTunnels.push(this.newSuperTcp.super_tcp.virt_if)
            }
          }
        })
      } // добавление интефейса в модемД при нескольких stcp
      else {
        Object.keys(this.newJson.modemd).forEach((modem_index) => {
          for (let st in this.newSuperTcp) {
            if ((this.newSuperTcp[st].iface.indexOf(modem_index.toLowerCase()) > -1 ||
            this.newSuperTcp[st].iface.indexOf("usb_" + modem_index.toLowerCase()) > -1) &&
            modem_index !== "modems" && modem_index !== "logger"){
              if (this.newJson.modemd[modem_index].wanTunnels.indexOf(this.newSuperTcp[st].virt_if) == -1) {
              this.newJson.modemd[modem_index].wanTunnels.push(this.newSuperTcp[st].virt_if)
              }
            }
          }
        })
      }
      // удаление интерфейса из wifi client при одном stcp
      if (!this.newJson.super_tcp.instance && this.newJson.wifi_client) {
        Object.keys(this.newWifiClient).forEach((wifi_index) => {
          if (this.newSuperTcp.super_tcp.iface.indexOf(wifi_index) == -1) {
              this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces.filter((item) =>{
                if (item != this.newSuperTcp.super_tcp.virt_if) return item
              })
          }
        })
      } // удаление интерфейса из wifi client при нескольких stcp
      else {
        if (this.newJson.wifi_client) {
          Object.keys(this.newWifiClient).forEach((wifi_index) => {
            for (let st in this.newSuperTcp) {
              if (this.newSuperTcp[st].iface.indexOf(wifi_index) == -1) {
                  this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces.filter((item) =>{
                    if (item != this.newSuperTcp[st].virt_if) return item
                })
              }
            }
          })
        }
      }
      // добавление интефейса в wifi client при одном stcp
      if (!this.newJson.super_tcp.instance && this.newJson.wifi_client) {
        Object.keys(this.newWifiClient).forEach((wifi_index) => {
          if (this.newSuperTcp.super_tcp.iface.indexOf(wifi_index) > -1){
              this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces ? this.newWifiClient[wifi_index].wan_ifaces : [];
              if (this.newWifiClient[wifi_index].wan_ifaces.indexOf(this.newSuperTcp.super_tcp.virt_if) == -1) {
                this.newWifiClient[wifi_index].wan_ifaces.push(this.newSuperTcp.super_tcp.virt_if)
              }
          }
        })
      } // добавление интефейса в wifi client при нескольких stcp
      else {
        if (this.newJson.wifi_client) {
          Object.keys(this.newWifiClient).forEach((wifi_index) => {
            for (let st in this.newSuperTcp) {
              if (this.newSuperTcp[st].iface.indexOf(wifi_index) > -1){
                  this.newWifiClient[wifi_index].wan_ifaces = this.newWifiClient[wifi_index].wan_ifaces ? this.newWifiClient[wifi_index].wan_ifaces : [];
                  if (this.newWifiClient[wifi_index].wan_ifaces.indexOf(this.newSuperTcp[st].virt_if) == -1) {
                  this.newWifiClient[wifi_index].wan_ifaces.push(this.newSuperTcp[st].virt_if)
                  }
              }
            }
          })
        }
      }
      // удаление интерфейса из lan при одном stcp
      if (!this.newJson.super_tcp.instance && this.newJson.network) {
        Object.keys(this.newJson.network).forEach((network_index) => {
          if (this.newJson.network[network_index].lan_wan && this.newSuperTcp.super_tcp.iface.indexOf(network_index) == -1) {
            this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan.filter((item) =>{
                if (item != this.newSuperTcp.super_tcp.virt_if) return item
              })
          }
        })
      } // удаление интерфейса из lan при нескольких stcp
      else {
        if (this.newJson.wifi_client) {
          Object.keys(this.newJson.network).forEach((network_index) => {
            for (let st in this.newSuperTcp) {
              if (this.newJson.network[network_index].lan_wan && this.newSuperTcp[st].iface.indexOf(network_index) == -1) {
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan.filter((item) =>{
                      if (item != this.newSuperTcp[st].virt_if) return item
                  })
              }
            }
          })
        }
      }
      // добавление интефейса в lan при одном stcp
      if (!this.newJson.super_tcp.instance && this.newJson.network) {
        Object.keys(this.newJson.network).forEach((network_index) => {
          if (!this.newJson.network[network_index].wan && this.newSuperTcp.super_tcp.iface.indexOf(network_index) > -1) {
            this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
              if (this.newJson.network[network_index].lan_wan.indexOf(this.newSuperTcp.super_tcp.virt_if) == -1) {
                this.newJson.network[network_index].lan_wan.push(this.newSuperTcp.super_tcp.virt_if)
              }
            }
        })
      } // добавление интефейса в lan при нескольких stcp
      else {
        if (this.newJson.network) {
          Object.keys(this.newJson.network).forEach((network_index) => {
            for (let st in this.newSuperTcp) {
              if (!this.newJson.network[network_index].wan && this.newSuperTcp[st].iface.indexOf(network_index) > -1){
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
                  if (this.newJson.network[network_index].lan_wan.indexOf(this.newSuperTcp[st].virt_if) == -1) {
                    this.newJson.network[network_index].lan_wan.push(this.newSuperTcp[st].virt_if)
                  }
              }
            }
          })
        }
      }
      this.forSuperTcp();
      //console.log(this.newJson);
    },
    updateWifiAp(data) {
      //console.log(data);
      let key1 = Object.keys(this.newJson.wifi_ap);
      let key2 = Object.keys(data);
      for (let key of key2) {
        key1.forEach((item) => {
          if (item == key) {
            if (data[item].old_ssid == ''|| data[item].ssids !== data[item].old_ssid) {
              let new_ssid = data[item].ssids;
              let old_ssid = data[item].old_ssid;
              this.newJson.wifi_ap[new_ssid] = {};
              this.newJson.wifi_ap[new_ssid] = data[item];

              this.newJson.wifi_ap[item] = {};
              this.newJson.wifi_ap[item].ssids = data[item].ssids;

              delete this.newJson.wifi_ap[new_ssid].ssids;
              delete this.newJson.wifi_ap[new_ssid].old_ssid;
              delete this.newJson.wifi_ap[new_ssid].old_name;
              delete this.newJson.wifi_ap[old_ssid];
            } else {
              this.newJson.wifi_ap[item] = {};
              this.newJson.wifi_ap[item].ssids = data[item].ssids;
              this.newJson.wifi_ap[data[item].ssids] = data[item];
              delete this.newJson.wifi_ap[data[item].ssids].old_ssid;
              delete this.newJson.wifi_ap[data[item].ssids].old_name;
              delete this.newJson.wifi_ap[data[item].ssids].ssids;
            }
          } else if (item !== key) {
            if (data[key2].old_name == item) {
              let old_ssid = this.newJson.wifi_ap[item].ssids;
              delete this.newJson.wifi_ap[old_ssid];
              let new_ssid = data[key2].ssids;
              this.newJson.wifi_ap[new_ssid] = {};
              this.newJson.wifi_ap[new_ssid] = data[key2];

              this.newJson.wifi_ap[key2] = {};
              this.newJson.wifi_ap[key2].ssids = data[key2].ssids;

              delete this.newJson.wifi_ap[item];
              delete this.newJson.wifi_ap[new_ssid].ssids;
              delete this.newJson.wifi_ap[new_ssid].old_ssid;
              delete this.newJson.wifi_ap[new_ssid].old_name;
            }
          }
        });
      }
      this.forWifiAp();
      //console.log(this.newJson);
    },
    updateWifiClient(data) {
      //console.log(data);
      let key1 = Object.keys(this.newJson.wifi_client);
      let key2 = Object.keys(data);
      for (let key of key2) {
        key1.forEach((item) => {
          if (item == key) {
            if (data[item].old_ssid == ''|| data[item].ssids !== data[item].old_ssid) {
              let new_ssid = data[item].ssids;
              let old_ssid = key1.filter((wifi_key) => wifi_key == data[item].old_ssid);
              this.newJson.wifi_client[new_ssid] = {};
              this.newJson.wifi_client[new_ssid] = data[item];

              this.newJson.wifi_client[item] = {};
              this.newJson.wifi_client[item].ssids = data[item].ssids;

              delete this.newJson.wifi_client[new_ssid].ssids;
              delete this.newJson.wifi_client[old_ssid];
              delete this.newJson.wifi_client[new_ssid].old_ssid;
              delete this.newJson.wifi_client[new_ssid].old_name;
            } else {
              this.newJson.wifi_client[item] = {};
              this.newJson.wifi_client[item].ssids = data[item].ssids;
              this.newJson.wifi_client[data[item].ssids] = data[item];
              delete this.newJson.wifi_client[data[item].ssids].old_ssid;
              delete this.newJson.wifi_client[data[item].ssids].old_name;
              delete this.newJson.wifi_client[data[item].ssids].ssids;
            }
          } else if (item !== key) {
            if (data[key2].old_name == item) {
              let old_ssid = this.newJson.wifi_client[item].ssids;
              delete this.newJson.wifi_client[old_ssid];
              let new_ssid = data[key2].ssids;
              this.newJson.wifi_client[new_ssid] = {};
              this.newJson.wifi_client[new_ssid] = data[key2];

              this.newJson.wifi_client[key2] = {};
              this.newJson.wifi_client[key2].ssids = data[key2].ssids;

              delete this.newJson.wifi_client[item];
              delete this.newJson.wifi_client[new_ssid].ssids;
              delete this.newJson.wifi_client[new_ssid].old_ssid;
              delete this.newJson.wifi_client[new_ssid].old_name;
          }
          }
        });
      }
      for (let rm in this.newRouteMan) {
        for (let i in data) {
          if (data[i].wan_ifaces.indexOf(this.newRouteMan[rm].tap) == -1) {
            this.newRouteMan[rm].multi_iface = this.newRouteMan[rm].multi_iface.filter((iface) => {
                if (iface.indexOf(i) == -1) {
                  return iface
                }
              })
          } else if (data[i].wan_ifaces.indexOf(this.newRouteMan[rm].tap) > -1) {
              this.newRouteMan[rm].multi_iface.push(i)
          }
        }
      }
      this.newJson = Object.assign(this.newJson, this.newRouteMan)
      for (let stcp in this.newSuperTcp) {
        for (let i in data) {
          if (data[i].wan_ifaces.indexOf(this.newSuperTcp[stcp].virt_if) == -1) {
            this.newSuperTcp[stcp].iface = this.newSuperTcp[stcp].iface.filter((iface) => {
                if (iface.indexOf(i) == -1) {
                  return iface
                }
              })
          } else if (data[i].wan_ifaces.indexOf(this.newSuperTcp[stcp].virt_if) > -1) {
              this.newSuperTcp[stcp].iface.push(i)
          }
        }
      }
      this.newJson = Object.assign(this.newJson, this.newSuperTcp)
      this.forWifiClient();
      //console.log(this.newJson);
    },
    updateModems(data) {
      //console.log(data);
      let key1 = Object.keys(this.newJson.modemd);
      let key2 = Object.keys(data);
      for (let key of key2) {
        key1.forEach((item) => {
          if (item == key) {
            this.newJson.modemd[item] = Object.assign(
              this.newJson.modemd[item],
              data[item]
            );
          } else {
            this.newJson.modemd[key] = data[key];
          }
        });
      }
      for (let item in this.newJson.modemd) {
        for (let rm in this.newRouteMan) {
          if (!(this.newJson.modemd[item].wanTunnels?.indexOf(this.newRouteMan[rm].tap) > -1)) {
            this.newRouteMan[rm].multi_iface = this.newRouteMan[rm].multi_iface.filter((iface) => {
              if (!(iface.toLowerCase().indexOf(item.toLowerCase()) > -1)) {
                return iface
              }
            })
          } else if (this.newJson.modemd[item].wanTunnels?.indexOf(this.newRouteMan[rm].tap) > -1) {
              let check_item = false;
              for (let iface of this.newRouteMan[rm].multi_iface) {
                if ((iface.toLowerCase().indexOf(item.toLowerCase()) > -1)) {
                  check_item = true;
                }
              }
              if (!check_item) this.newRouteMan[rm].multi_iface.push("usb_" + item.toLowerCase())
          }
        }
      }
      this.newJson = Object.assign(this.newJson, this.newRouteMan)

      for (let item in this.newJson.modemd) {
        for (let stcp in this.newSuperTcp) {
          if (!(this.newJson.modemd[item].wanTunnels?.indexOf(this.newSuperTcp[stcp].virt_if) > -1)) {
            this.newSuperTcp[stcp].iface = this.newSuperTcp[stcp].iface.filter((iface) => {
              if (!(iface.toLowerCase().indexOf(item.toLowerCase()) > -1)) {
                return iface
              }
            })
          } else if (this.newJson.modemd[item].wanTunnels?.indexOf(this.newSuperTcp[stcp].virt_if) > -1) {
            let check_item = false;
            for (let iface of this.newSuperTcp[stcp].iface) {
              if ((iface.toLowerCase().indexOf(item.toLowerCase()) > -1)) {
                check_item = true;
              }
            }
            if (!check_item) this.newSuperTcp[stcp].iface.push("usb_" + item.toLowerCase())
          }
        }
      }
      this.newJson = Object.assign(this.newJson, this.newSuperTcp);

      for (let modem in data) {
        if (!this.newJson.simprofile && data[modem].apn !== data[modem].old_apn) {
          this.newJson.simprofile = {};
          this.newJson.simprofile[modem] = {};
          this.newJson.simprofile[modem].apn = data[modem].apn;
        } else if (this.newJson.simprofile && data[modem].apn !== data[modem].old_apn) {
          for (let profile in this.newJson.simprofile) {
            if (data[modem] == this.newJson.simprofile[profile]) {
              this.newJson.simprofile[profile].apn = data[modem].apn;
            } else if (data[modem] !== this.newJson.simprofile[profile]) {
              this.newJson.simprofile[modem] = {};
              this.newJson.simprofile[modem].apn = data[modem].apn;
            }
          }
        }
      }
      this.forModems();
      //console.log(this.newJson);
    },
    deleteLan(header) {
      delete this.newJson.network[header];
      this.forLanNetwork();
    },

    deleteWifiAp(header) {
      for (let i in this.newJson.wifi_ap) {
        if (this.newJson.wifi_ap[header].ssids.indexOf(i) > -1) {
          delete this.newJson.wifi_ap[i];
        }
      }
      if (this.newJson.wifi_ap.ifaces) {
        if (typeof this.newJson.wifi_ap.ifaces === "string") {
          this.newJson.wifi_ap.ifaces = this.newJson.wifi_ap.ifaces.split(",");
        } else {
          this.newJson.wifi_ap.ifaces = this.newJson.wifi_ap.ifaces;
        }
        for (let i in this.newJson.wifi_ap.ifaces) {
          if (this.newJson.wifi_ap.ifaces[i].indexOf(header) > -1) {
            delete this.newJson.wifi_ap.ifaces[i];
          }
        }
        this.newJson.wifi_ap.ifaces = this.newJson.wifi_ap.ifaces.filter(
          (item) => item
        );
      }
      delete this.newJson.wifi_ap[header];
      this.forWifiAp();
      //console.log(this.newJson);
    },
    deleteWifiClient(header) {
      for (let i in this.newJson.wifi_client) {
        if (this.newJson.wifi_client[header].ssids.indexOf(i) > -1) {
          delete this.newJson.wifi_client[i];
        }
      }
      if (this.newJson.wifi_client.ifaces) {
        if (typeof this.newJson.wifi_client.ifaces === "string") {
          this.newJson.wifi_client.ifaces =
            this.newJson.wifi_client.ifaces.split(",");
        } else {
          this.newJson.wifi_client.ifaces = this.newJson.wifi_client.ifaces;
        }
        for (let i in this.newJson.wifi_client.ifaces) {
          if (this.newJson.wifi_client.ifaces[i].indexOf(header) > -1) {
            delete this.newJson.wifi_client.ifaces[i];
          }
        }
        this.newJson.wifi_client.ifaces =
          this.newJson.wifi_client.ifaces.filter((item) => item);
      }
      delete this.newJson.wifi_client[header];
      this.forWifiClient();
    },
    deleteWanSuperTcp(header) {
      if (this.newJson.super_tcp.instance) {
        delete this.newJson[header];
        for (let i in this.newJson.super_tcp.instance) {
          if (this.newJson.super_tcp.instance[i].indexOf(header) > -1) {
            delete this.newJson.super_tcp.instance[i];
          }
        }
        this.newJson.super_tcp.instance =
          this.newJson.super_tcp.instance.filter((item) => item);
        if (this.newJson.super_tcp.instance.length == 0) {
          delete this.newJson.super_tcp;
        }
      } else {
        delete this.newJson.super_tcp;
      }
      this.forSuperTcp();
    },
    deleteWanRouteMan(header) {
      if (this.newJson.route_man.instance) {
        delete this.newJson[header];
        for (let i in this.newJson.route_man.instance) {
          if (this.newJson.route_man.instance[i].indexOf(header) > -1) {
            delete this.newJson.route_man.instance[i];
          }
        }
        this.newJson.route_man.instance =
          this.newJson.route_man.instance.filter((item) => item);
        if (this.newJson.route_man.instance.length == 0) {
          delete this.newJson.route_man;
        }
      } else {
        delete this.newJson.route_man;
      }
      this.forRouteMan();
    },
    selected_block(block) {
      this.block = block;
    },
    restart_page() {
      window.open("#/modem/" + this.dev_fid + "/config", "_self");
    },
    to_zero() {
      let flag = true;
      if (this.$route.params.to_zero === "to_zero") {
        if (confirm("Обнулить версию конфигурации для " + this.dev_fid + " ?")) {
          flag = false;
          this.$http.api.resetConfigVersion(this.dev_fid, () => {
            this.load_conf();
          });
        }
        this.restart_page();
      }
      if (flag) {
        this.load_conf();
      }
    },
    load_conf() {
      this.show = false;
      if (this.$route.name === "device_section") {
        this.$http.v1.getDeviceConfigJson(this.dev_fid, (response) => {
          this.this_version = response.data.ver
          this.$set(this, "original_config", {...response.data.config.main});
          this.$set(this, "newJson", response.data.config.main);

          //console.log(this.newJson);
          this.forLanNetwork();
          this.forRouteMan();
          this.forSuperTcp();
          this.forWifiClient();
          this.forWifiAp();
          this.forModems();
          this.getAPN();
          this.interfacesForWifiClients();
        });
      }
    },
    addNewModem() {
      if (!this.newJson.modemd) {
        this.$set(this.newJson, "modemd", []);
        this.$set(this.newJson.modemd, "LTE Modem M1", {
          powered_on: 1,
          gps: false,
          allow_international_roaming: false,
          ping_servers: [],
          mode: "AUTO",
          apn: "",
        });
        this.forModems();
      } else if (this.newJson.modemd) {
        let numberOfModems = Object.keys(this.newModems).length;
        this.version.forEach((item) => {
          if (item.indexOf("hw") > -1) {
            let version = parseFloat(item.split(":")[1]);
            this.versionHW = Math.trunc(version);
          }
        });
        if (
          (this.versionHW == 4 && numberOfModems < 4) ||
          (this.versionHW == 5 && numberOfModems < 8) ||
          (this.versionHW == 6 && numberOfModems < 2)
        ) {
          let modem_new = {
            powered_on: 1,
            gps: false,
            allow_international_roaming: false,
            ping_servers: [],
            mode: "AUTO",
            apn: "",
          };
          let names = Object.keys(this.newModems);
          let name = "M" + (names.length + 1);
          this.$set(this.newJson.modemd, name, modem_new);
          this.newJson.modemd.modems.push(name);
          this.forModems();
        } else {
          this.global_notify(
            "danger",
            this.translate("device.config_dashboard.info")
          );
        }
      }
    },
    addNewWifiAp() {
      if (!this.newJson.wifi_ap) {
        this.$set(this.newJson, "wifi_ap", []);
        this.$set(this.newJson.wifi_ap, "wlan_1", {
          ssids: "",
          pass: "",
          band: "",
          channel: "",
          bridge: "",
          max_clients: "",
          hide_ssid: false,
        });
        this.forWifiAp();
      } else if (this.newJson.wifi_ap) {
        let wlan_new = {
          ssids: "",
          pass: "",
          band: "",
          channel: "",
          bridge: "",
          max_clients: "",
          hide_ssid: false,
        };
        let names = Object.keys(this.newWifiAp);
        let name = "wlan_" + (names.length + 1);
        this.$set(this.newJson.wifi_ap, name, wlan_new);
        if (this.newJson.wifi_ap.ifaces) {
          if (typeof this.newJson.wifi_ap.ifaces === "string") {
            this.newJson.wifi_ap.ifaces =
              this.newJson.wifi_ap.ifaces + "," + name;
          } else {
            this.newJson.wifi_ap.ifaces.push(name);
          }
        }
        this.forWifiAp();
      }
    },
    addNewWifiClient() {
      if (!this.newJson.wifi_client) {
        this.$set(this.newJson, "wifi_client", []);
        this.$set(this.newJson.wifi_client, "wlan_m1", {
          ssids: "",
        });
        this.forWifiClient();
      } else if (this.newJson.wifi_client) {
        let wlan_new = {
          ssids: "",
        };
        let names = Object.keys(this.newWifiClient);
        let name = "wlan_m" + (names.length + 1);
        this.$set(this.newJson.wifi_client, name, wlan_new);
        if (this.newJson.wifi_client.ifaces) {
          if (typeof this.newJson.wifi_client.ifaces === "string") {
            this.newJson.wifi_client.ifaces =
              this.newJson.wifi_client.ifaces + "," + name;
          } else {
            this.newJson.wifi_client.ifaces.push(name);
          }
        }
        this.forWifiClient();
      }
    },
    addNewSuperTcp() {
      if (!this.newJson.super_tcp) {
        this.$set(this.newJson, "super_tcp", {
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          servers: "",
          server_port: "",
          iface: "",
          type: "nat",
          virt_if: "stcp",
          servers_round_robin: "Off",
          interface_mtu: "",
          auth: "",
        });
      } else if (this.newJson.super_tcp && !this.newJson.super_tcp.instance) {
        this.$set(this.newJson, "new_super_tcp", this.newJson.super_tcp);
        this.newJson.super_tcp = { instance: "new_super_tcp" };
        delete this.newSuperTcp.super_tcp;

        let new_stcp = {
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          servers: "",
          server_port: "",
          iface: "",
          type: "nat",
          virt_if: "",
          servers_round_robin: "Off",
          interface_mtu: "",
          auth: "",
        };

        let type_instance = typeof this.newJson.super_tcp.instance == "string";
        let names = type_instance
          ? this.newJson.super_tcp.instance.split(",")
          : this.newJson.super_tcp.instance;
        let new_name = "new_super_tcp" + (names.length + 1);
        new_stcp.virt_if = new_name;
        if (type_instance) {
          this.newJson.super_tcp.instance =
            this.newJson.super_tcp.instance + "," + new_name;
        } else {
          this.newJson.super_tcp.instance.push(new_name);
        }
        this.$set(this.newJson, new_name, new_stcp);
      } else {
        delete this.newSuperTcp.super_tcp;
        let new_stcp = {
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          servers: "",
          server_port: "",
          iface: "",
          type: "nat",
          virt_if: "",
          servers_round_robin: "Off",
          interface_mtu: "",
          auth: "",
        };
        let type_instance = typeof this.newJson.super_tcp.instance == "string";
        let names = type_instance
          ? this.newJson.super_tcp.instance.split(",")
          : this.newJson.super_tcp.instance;
        let new_name = "new_super_tcp" + (names.length + 1);
        new_stcp.virt_if = new_name;
        if (type_instance) {
          this.newJson.super_tcp.instance =
            this.newJson.super_tcp.instance + "," + new_name;
        } else {
          this.newJson.super_tcp.instance.push(new_name);
        }
        this.$set(this.newJson, new_name, new_stcp);
      }
      this.forSuperTcp();
    },
    addNewRouteMan() {
      if (!this.newJson.route_man) {
        this.$set(this.newJson, "route_man", {
          auth: "",
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          local_ports: "",
          multi_iface: "",
          multi_server: "",
          tap: "tap0",
          server_port: "2000",
        });
      } else if (this.newJson.route_man && !this.newJson.route_man.instance) {
        this.$set(this.newJson, "new_route_man", this.newJson.route_man);
        this.newJson.route_man = { instance: "new_route_man" };
        delete this.newRouteMan.route_man;

        let new_route_man = {
          auth: "",
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          local_ports: "",
          multi_iface: "",
          multi_server: "",
          tap: "tap0",
          server_port: "2000",
        };

        let type_instance = typeof this.newJson.route_man.instance == "string";
        let names = type_instance
          ? this.newJson.route_man.instance.split(",")
          : this.newJson.route_man.instance;
        let new_name = "new_route_man" + (names.length + 1);
        new_route_man.tap = new_name;
        if (type_instance) {
          this.newJson.route_man.instance =
            this.newJson.route_man.instance + "," + new_name;
        } else {
          this.newJson.route_man.instance.push(new_name);
        }
        this.$set(this.newJson, new_name, new_route_man);
      } else {
        delete this.newRouteMan.route_man;
        let new_route_man = {
          auth: "",
          default_route: "",
          local_ip: "",
          local_mask: "",
          gateway: "",
          local_ports: "",
          multi_iface: "",
          multi_server: "",
          remote_ports: "",
          tap: "tap0",
          server_port: "2000",
        };

        let type_instance = typeof this.newJson.route_man.instance == "string";
        let names = type_instance
          ? this.newJson.route_man.instance.split(",")
          : this.newJson.route_man.instance;
        let new_name = "new_route_man" + (names.length + 1);
        new_route_man.tap = new_name;
        if (type_instance) {
          this.newJson.route_man.instance =
            this.newJson.route_man.instance + "," + new_name;
        } else {
          this.newJson.route_man.instance.push(new_name);
        }
        this.$set(this.newJson, new_name, new_route_man);
      }
      this.forRouteMan();
    },
    getAPN() {
      this.$http.v1.getSimAPN(this.dev_fid, (response) => {
          let keys = Object.keys(this.newModems);
          for (let apn of response.data) {
            keys.forEach((item) => {
              if (
                item.toLowerCase() == "m" + apn.slot ||
                item.toLowerCase() == "usb_m" + apn.slot
              )
                this.newModems[item].apn = apn.apn;
            });
          }
        });
    },
    forModems() {
      if (this.newJson.modemd) {
        if (!this.newJson.modemd.modems && !this.newJson.modemd.iface) {
          this.newJson.modemd.modems = "M1,M2,M3,M4";
        }
        if (this.newJson.modemd.iface) {
          this.newJson.modemd.modems = this.newJson.modemd.iface;
          delete this.newJson.modemd.iface;
        }
        let modems = this.newJson.modemd.modems;
        if (modems.indexOf("..") > -1) {
          modems = this.search_double_dot(modems);
        } else if (modems.indexOf(",") > -1) {
          modems = modems.split(",");
        }
        modems = modems.map((item) => item.replace("usb_", ""));
        this.newJson.modemd.modems = modems.map((item) => item.toUpperCase());
        for (let modem of modems) {
          this.newModems[modem.toUpperCase()] = {};
        }
        //модемы со спец настройками в modemd помещаем в новый блок newModems
        let regexp = /^(usb_m|m|M|)[\d](.\d)?$/;
        let keysModemd = Object.keys(this.newJson.modemd);
        let filterModems = keysModemd.filter((item) => regexp.test(item));
        let mapModems = filterModems.map((item) => regexp.exec(item)[0]);
        mapModems = mapModems.map((item) => item.replace("usb_", ""));
        for (let i of mapModems) {
          if (this.newJson.modemd[i]) {
            this.modemSpecialSettings[i.toUpperCase()] = this.newJson.modemd[i];
            if (!this.newJson.modemd[i.toUpperCase()]) {
            this.newJson.modemd[i.toUpperCase()] = this.newJson.modemd[i];
            delete this.newJson.modemd[i];
            }
          }
        }
        //

        let key1 = Object.keys(this.newModems);
        let key2 = Object.keys(this.modemSpecialSettings);
        for (let key of key2) {
          key1.forEach((item) => {
            if (item == key) {
              this.newModems = Object.assign(
                this.newModems,
                this.modemSpecialSettings
              );
            }
          });
        }

        /* this.$http.v1.getSimAPN(this.dev_id, (response) => {
          let keys = Object.keys(this.newModems);
          for (let apn of response.data) {
            keys.forEach((item) => {
              if (
                item.toLowerCase() == "m" + apn.slot ||
                item.toLowerCase() == "usb_m" + apn.slot
              )
                this.newModems[item].apn = apn.apn;
            });
          }
        }); */

        //проверка route_man на соответствие модемов для опеределения wan tunnels
        if (this.newJson.route_man?.multi_iface) {
          if (this.newJson.route_man.multi_iface.indexOf("..") > -1) {
            this.newJson.route_man.multi_iface = this.search_double_dot(
              this.newJson.route_man.multi_iface
            );
          } else if (this.newJson.route_man.multi_iface.indexOf(",") > -1) {
            this.newJson.route_man.multi_iface
              this.newJson.route_man.multi_iface.split(",");
          }
          let keysModems = Object.keys(this.newModems);
          for (let i in keysModems) {
            for (let k in this.newJson.route_man.multi_iface) {
              if (
                this.newJson.route_man.multi_iface[k]
                  .toLowerCase()
                  .indexOf(keysModems[i].toLowerCase()) > -1
              ) {
                this.newModems[keysModems[i]].wanTunnels = [
                  this.newJson.route_man.tap,
                ];
              }
            }
          }

          this.listWanTunnels.push(this.newJson.route_man.tap);
        } else if (this.newJson.route_man?.instance) {
          let newJsonKeys = Object.keys(this.newJson);
          if (this.newJson.route_man.instance.indexOf("..") > -1) {
            this.newJson.route_man.instance = this.search_double_dot(
              this.newJson.route_man.instance
            );
          } else if (this.newJson.route_man.instance.indexOf(",") > -1) {
            this.newJson.route_man.instance =
              this.newJson.route_man.instance.split(",");
          }
          for (let i in this.newJson.route_man.instance) {
            for (let k in newJsonKeys) {
              if (
                newJsonKeys[k].indexOf(this.newJson.route_man.instance[i]) > -1
              ) {
                if (
                  this.newJson[
                    this.newJson.route_man.instance[i]
                  ].multi_iface.indexOf("..") > -1
                ) {
                  this.newJson[this.newJson.route_man.instance[i]].multi_iface =
                    this.search_double_dot(
                      this.newJson[this.newJson.route_man.instance[i]]
                        .multi_iface
                    );
                } else if (
                  this.newJson[
                    this.newJson.route_man.instance[i]
                  ].multi_iface.indexOf(",") > -1
                ) {
                  this.newJson[this.newJson.route_man.instance[i]].multi_iface =
                    this.newJson[
                      this.newJson.route_man.instance[i]
                    ].multi_iface.split(",");
                }
                for (let j in this.newJson[this.newJson.route_man.instance[i]]
                  .multi_iface) {
                  let keysModems = Object.keys(this.newModems);
                  for (let n in keysModems) {
                    if (
                      this.newJson[
                        this.newJson.route_man.instance[i]
                      ].multi_iface[j]
                        .toLowerCase()
                        .indexOf(keysModems[n].toLowerCase()) > -1
                    ) {
                      //this.wanTunnelsModems.push(this.newJson[this.newJson.route_man.instance[i]].tap)
                      if (!this.newModems[keysModems[n]].wanTunnels) {
                        this.newModems[keysModems[n]].wanTunnels = [];
                      }
                      if (
                        this.newModems[keysModems[n]].wanTunnels.indexOf(
                          this.newJson[this.newJson.route_man.instance[i]].tap
                        ) == -1
                      ) {
                        this.newModems[keysModems[n]].wanTunnels.push(
                          this.newJson[this.newJson.route_man.instance[i]].tap
                        );
                      }
                    }
                  }
                  this.listWanTunnels.push(
                    this.newJson[this.newJson.route_man.instance[i]].tap
                  );
                }
              }
            }
            this.listWanTunnels = [...new Set(this.listWanTunnels)];
          }
        }
        //проверка super_tcp на соответствие модемов для опеределения wan tunnels
        if (this.newJson.super_tcp?.iface) {
          if (this.newJson.super_tcp.iface.indexOf("..") > -1) {
            this.newJson.super_tcp.iface = this.search_double_dot(
              this.newJson.super_tcp.iface
            );
          } else if (this.newJson.super_tcp.iface.indexOf(",") > -1) {
            this.newJson.super_tcp.iface =
              this.newJson.super_tcp.iface.split(",");
          }
          let keysModems = Object.keys(this.newModems);
          for (let i in keysModems) {
            for (let k in this.newJson.super_tcp.iface) {
              if (
                this.newJson.super_tcp.iface[k]
                  .toLowerCase()
                  .indexOf(keysModems[i].toLowerCase()) > -1
              ) {
                this.newModems[keysModems[i]].wanTunnels = [
                  this.newJson.super_tcp.virt_if,
                ];
              }
            }
          }
          this.listWanTunnels.push(this.newJson.super_tcp.virt_if);
        } else if (this.newJson.super_tcp?.instance) {
          let newJsonKeys = Object.keys(this.newJson);
          if (this.newJson.super_tcp.instance.indexOf("..") > -1) {
            this.newJson.super_tcp.instance = this.search_double_dot(
              this.newJson.super_tcp.instance
            );
          } else if (this.newJson.super_tcp.instance.indexOf(",") > -1) {
            this.newJson.super_tcp.instance =
              this.newJson.super_tcp.instance.split(",");
          }
          for (let i in this.newJson.super_tcp.instance) {
            for (let k in newJsonKeys) {
              if (
                newJsonKeys[k].indexOf(this.newJson.super_tcp.instance[i]) > -1
              ) {
                if (
                  this.newJson[
                    this.newJson.super_tcp.instance[i]
                  ].iface.indexOf("..") > -1
                ) {
                  this.newJson[this.newJson.super_tcp.instance[i]].iface =
                    this.search_double_dot(
                      this.newJson[this.newJson.super_tcp.instance[i]].iface
                    );
                } else if (
                  this.newJson[
                    this.newJson.super_tcp.instance[i]
                  ].iface.indexOf(",") > -1
                ) {
                  this.newJson[this.newJson.super_tcp.instance[i]].iface =
                    this.newJson[
                      this.newJson.super_tcp.instance[i]
                    ].iface.split(",");
                }
                for (let j in this.newJson[this.newJson.super_tcp.instance[i]]
                  .iface) {
                  let keysModems = Object.keys(this.newModems);
                  for (let n in keysModems) {
                    if (
                      this.newJson[this.newJson.super_tcp.instance[i]].iface[j]
                        .toLowerCase()
                        .indexOf(keysModems[n].toLowerCase()) > -1
                    ) {
                      if (!this.newModems[keysModems[n]].wanTunnels) {
                        this.newModems[keysModems[n]].wanTunnels = [];
                      }
                      if (
                        this.newModems[keysModems[n]].wanTunnels.indexOf(
                          this.newJson[this.newJson.super_tcp.instance[i]]
                            .virt_if
                        ) == -1
                      ) {
                        this.newModems[keysModems[n]].wanTunnels.push(
                          this.newJson[this.newJson.super_tcp.instance[i]]
                            .virt_if
                        );
                      }
                    }
                  }
                  this.listWanTunnels.push(
                    this.newJson[this.newJson.super_tcp.instance[i]].virt_if
                  );
                }
              }
            }
          }
          this.listWanTunnels = [...new Set(this.listWanTunnels)];
        }
      }
    },
    forWifiAp() {
      this.newWifiAp = {};
      if (this.newJson.wifi_ap) {
        let interfaces = Object.keys(this.newJson.wifi_ap);
        for (let i in interfaces) {
          if (interfaces[i].indexOf("wlan") === 0) {
            this.$set(this.newWifiAp, interfaces[i], {
              ...this.newJson.wifi_ap[interfaces[i]],
            });
          }
        }
        for (let k in this.newWifiAp) {
          for (let i in this.newJson.wifi_ap) {
            if (i == this.newWifiAp[k].ssids) {
              this.newWifiAp[k] = Object.assign(
                this.newWifiAp[k], this.newJson.wifi_ap[i]
            );
            }
          }
        }
        this.lanIfacesForWifi = Object.keys(this.newJson.network);
      }
    },
    forWifiClient() {
      this.newWifiClient = {};
      if (this.newJson.wifi_client) {
        let interfaces = Object.keys(this.newJson.wifi_client);
        for (let i in interfaces) {
          if (interfaces[i].indexOf("wlan") === 0) {
            this.$set(this.newWifiClient, interfaces[i], {
              ...this.newJson.wifi_client[interfaces[i]],
            });
          }
        }
        for (let k in this.newWifiClient) {
          for (let i in this.newJson.wifi_client) {
            if (i == this.newWifiClient[k].ssids) {
              this.newWifiClient[k] = Object.assign(
                this.newWifiClient[k], this.newJson.wifi_client[i]
            );
            }
          }
        }
        for (let wifi in this.newWifiClient) {
          if (!this.newWifiClient[wifi].wan_ifaces) {
            this.newWifiClient[wifi].wan_ifaces = [];
            for (let tcp in this.newSuperTcp) {
              // для новосозданного вай фай клиента
              if (this.newSuperTcp[tcp]?.iface.indexOf(wifi) > -1) {
                this.newWifiClient[wifi]?.wan_ifaces.push(this.newSuperTcp[tcp].virt_if);
              }
            }
            for (let route_man in this.newRouteMan) {
              // для новосозданного вай фай клиента
              if (this.newRouteMan[route_man].multi_iface.indexOf(wifi) > -1) {
                this.newWifiClient[wifi].wan_ifaces.push(this.newRouteMan[route_man].tap);
              }
            }
          }
          this.newWifiClient[wifi].wan_ifaces_all = [];
          for (let tcp in this.newSuperTcp) {
            this.newWifiClient[wifi].wan_ifaces_all.push(this.newSuperTcp[tcp]?.virt_if);
          }
          for (let route_man in this.newRouteMan) {
            this.newWifiClient[wifi].wan_ifaces_all.push(this.newRouteMan[route_man].tap);
          }
        }
      }
    },
    forRouteMan() {
      this.newRouteMan = {};
      if (this.newJson.route_man) {
        if (this.newJson.route_man.instance) {
          let instance =
            typeof this.newJson.route_man.instance === "string"
              ? this.newJson.route_man.instance.split(",")
              : this.newJson.route_man.instance;
          for (let i in instance) {
            if (this.newJson[instance[i]]) {
              this.$set(this.newRouteMan, instance[i], {
                ...this.newJson[instance[i]],
              });
            }
          }
        } else {
          this.newRouteMan = {
            route_man: this.newJson.route_man,
          };
        }
      } else {
        this.newRouteMan = {};
      }
      for (let route_man in this.newRouteMan) {
        // изменение маски
        if (!this.newRouteMan[route_man].local_mask) {
          this.newRouteMan[route_man].local_mask = "255.255.255.0";
        } else if (this.newRouteMan[route_man].local_mask.indexOf("/") > -1) {
          let newMask = this.newRouteMan[route_man].local_mask.slice(1);
          let calculateMask = ipSubnetCalculator.calculateSubnetMask(
            this.newRouteMan[route_man].local_ip, Number(newMask)
          );
          this.newRouteMan[route_man].local_mask = calculateMask.prefixMaskStr;
        }
        // изменение шлюза
        if (!this.newRouteMan[route_man].gateway && this.newRouteMan[route_man].local_ip && this.newRouteMan[route_man].local_ip !== "auto"
        ) {
          let calculateGateway = ipSubnetCalculator.calculateCIDRPrefix(this.newRouteMan[route_man].local_ip, this.newRouteMan[route_man].local_mask);
          let ipLowStr = calculateGateway.ipLowStr;
          this.newRouteMan[route_man].gateway = ipLowStr.substring(0, ipLowStr.length - 1) + "1";
        }
      }
    },
    forSuperTcp() {
      this.newSuperTcp = {};
      if (this.newJson.super_tcp) {
        if (this.newJson.super_tcp.instance) {
          let instance =
            typeof this.newJson.super_tcp.instance === "string"
              ? this.newJson.super_tcp.instance.split(",")
              : this.newJson.super_tcp.instance;
          for (let i in instance) {
            if (this.newJson[instance[i]]) {
              this.$set(this.newSuperTcp, instance[i], {
                ...this.newJson[instance[i]],
              });
            }
          }
        } else {
          this.newSuperTcp = {
            super_tcp: this.newJson.super_tcp,
          };
        }
      } else {
        this.newSuperTcp = {};
      }
      for (let stcp in this.newSuperTcp) {
        // проверка порта у сервера
        for (let server in this.newSuperTcp[stcp].servers) {
          if (typeof this.newSuperTcp[stcp].servers == "object") {
            if ( !(this.newSuperTcp[stcp].servers[server].indexOf(":") > -1) && !this.newSuperTcp[stcp].server_port) {
              this.newSuperTcp[stcp].servers[server] = this.newSuperTcp[stcp].servers[server] + ":5006";
            } else if ( !(this.newSuperTcp[stcp].servers[server].indexOf(":") > -1) && this.newSuperTcp[stcp].server_port) {
              this.newSuperTcp[stcp].servers[server] = this.newSuperTcp[stcp].servers[server] + ":" + this.newSuperTcp[stcp].server_port;
            }
          } else if (typeof this.newSuperTcp[stcp].servers == "string" && this.newSuperTcp[stcp].type !== "nat") {
              if ( !(this.newSuperTcp[stcp].servers.indexOf(":") > -1) && !this.newSuperTcp[stcp].server_port) {
                this.newSuperTcp[stcp].servers = this.newSuperTcp[stcp].servers + ":5006";
              } else if ( !(this.newSuperTcp[stcp].servers.indexOf(":") > -1) && this.newSuperTcp[stcp].server_port) {
                this.newSuperTcp[stcp].servers = this.newSuperTcp[stcp].servers + ":" + this.newSuperTcp[stcp].server_port;
              }
          }
        }
        // изменение маски
        if (!this.newSuperTcp[stcp].local_mask) {
          this.newSuperTcp[stcp].local_mask = "255.255.255.0";
        } else if (this.newSuperTcp[stcp].local_mask.indexOf("/") > -1) {
          let newMask = this.newSuperTcp[stcp].local_mask.slice(1);
          let calculateMask = ipSubnetCalculator.calculateSubnetMask(this.newSuperTcp[stcp].local_ip,Number(newMask));
          this.newSuperTcp[stcp].local_mask = calculateMask.prefixMaskStr;
        }
        // изменение шлюза
        if (!this.newSuperTcp[stcp].gateway && this.newSuperTcp[stcp].local_ip && this.newSuperTcp[stcp].local_ip !== "auto") {
          let calculateGateway = ipSubnetCalculator.calculateCIDRPrefix(this.newSuperTcp[stcp].local_ip, this.newSuperTcp[stcp].local_mask);
          let ipLowStr = calculateGateway.ipLowStr;
          this.newSuperTcp[stcp].gateway = ipLowStr.substring(0, ipLowStr.length - 1) + "1";
        }
      }
    },
    addNewNetwork() {
      let LAN = {
        iface: [],
        local_ip: "",
        type: "",
        wan: "",
        gateway: "",
        mask: "",
        mac: "",
        interface: "",
        dhcp_server_enable: false,
        dhcp: {
          end: "",
          start: "",
          dns: "",
          gateway: "",
        },
      };
      let names = Object.keys(this.newJson.network);
      let name = "br" + names.length;
      if (this.checkNameNewNetwork(name)) {
        name = "br" + (names.length + 1);
      }
      this.$set(this.newJson.network, name, LAN);
    },
    checkNameNewNetwork(name) {
      return Object.keys(this.newJson.network).indexOf(name) > -1
    },
  interfacesForWifiClients() {
      this.optionsPorts = this.interfaces.ethernets;
      if (this.newJson?.wifi_ap) {
        Object.keys(this.newJson.wifi_ap).forEach((ap_index) => {
            if (this.interfaces.wifis.indexOf(ap_index) > -1) {
              this.interfaces.wifis = this.interfaces.wifis.filter((item) =>{
                if (item = this.newJson.wifi_ap[ap_index]) return !item
              })
            }
        })
      }
      this.optionsWAN = this.interfaces.modems.concat(this.interfaces.wifis);
      let networkKeys = Object.keys(this.newJson.network);
      this.optionsWAN = this.optionsWAN.concat(networkKeys);
      this.optionsWAN = this.optionsWAN.filter((item) => item);
    },
    forLanNetwork() {
      delete this.newJson.network.iface;
      if (this.newJson.dnsmasq) {
        if (this.newJson.dnsmasq.interface.indexOf("..") > -1) {
          this.newJson.dnsmasq.interface = this.search_double_dot(
            this.newJson.dnsmasq.interface
          );
        } else if (this.newJson.dnsmasq.interface.indexOf(",") > -1) {
          this.newJson.dnsmasq.interface =
            this.newJson.dnsmasq.interface.split(",");
        } else if (typeof this.newJson.dnsmasq.interface == "string") {
          this.newJson.dnsmasq.interface =
            this.newJson.dnsmasq.interface.split();
        }
        if (!this.newJson.network.dhcp) {
          for (let i in this.newJson.network) {
            this.newJson.network[i].dhcp_server_enable = false;
            this.newJson.network[i].dhcp = {
              dhcp_end: "",
              dhcp_start: "",
              dns: "",
              gateway: "",
              //local_domain: ""
            };
          }
        }
        for (let network_key of Object.keys(this.newJson.network)) {
          for (let dnsmasq_interface_key of this.newJson.dnsmasq.interface) {
            if (this.newJson.network[dnsmasq_interface_key]) {
              this.newJson.network[dnsmasq_interface_key].dhcp_server_enable = true;
            } else {
              this.newJson.network[network_key].dhcp_server_enable = false;
            }
          }
        }

        for (let dnsmasq_key of Object.keys(this.newJson.dnsmasq)) {
          for (let network of Object.keys(this.newJson.network)) {
            if (dnsmasq_key === network) {
              this.newJson.network[dnsmasq_key].dhcp.dhcp_start = this.newJson.dnsmasq[dnsmasq_key].dhcp_start || this.newJson.dnsmasq[dnsmasq_key].start ||"";
              this.newJson.network[dnsmasq_key].dhcp.dhcp_end = this.newJson.dnsmasq[dnsmasq_key].dhcp_end || this.newJson.dnsmasq[dnsmasq_key].end || "";
              this.newJson.network[dnsmasq_key].dhcp.dns = this.newJson.dnsmasq[dnsmasq_key].dns || "";
              this.newJson.network[dnsmasq_key].dhcp.gateway = this.newJson.dnsmasq[dnsmasq_key].gateway || "";
            }
          }
        }
      }
      for (let item in this.newJson.network) {
        // separationLocalIp
        if (this.newJson.network[item].local_ip) {
          if (this.newJson.network[item].local_ip.indexOf("/") > -1) {
            let splitIp = this.newJson.network[item].local_ip.split("/");
            let calculateMask = ipSubnetCalculator.calculateSubnetMask(splitIp[0], Number(splitIp[1]));
            this.newJson.network[item].local_ip = splitIp[0];
            this.newJson.network[item].mask = calculateMask.prefixMaskStr;
          }
        }
        // changeMask
        if (this.newJson.network[item].mask?.indexOf("/") > -1) {
          let newMask = this.newJson.network[item].mask.slice(1);
          let calculateMask = ipSubnetCalculator.calculateSubnetMask(this.lanData.local_ip, Number(newMask));
          this.newJson.network[item].mask = calculateMask.prefixMaskStr;
        }
      }
      //поиск уже выбранных WAN interfaces для LAN в режиме WAN в super_tcp
      if (this.newJson.super_tcp?.iface) {
        if (this.newJson.super_tcp.iface.indexOf("..") > -1) {
          this.newJson.super_tcp.iface = this.search_double_dot(
            this.newJson.super_tcp.iface
          );
        } else if (this.newJson.super_tcp.iface.indexOf(",") > -1) {
          this.newJson.super_tcp.iface =
            this.newJson.super_tcp.iface.split(",");
        }
        Object.keys(this.newJson.network).forEach((key) => {
          if (this.newJson.super_tcp.iface.indexOf(key) > -1) {
            /* this.selectedLanWanInterfaces[key] = this.selectedLanWanInterfaces[key] ? this.selectedLanWanInterfaces[key] : [];
            this.selectedLanWanInterfaces[key].push(this.newJson.super_tcp.virt_if); */
            this.newJson.network[key].lan_wan = this.newJson.network[key].lan_wan ? this.newJson.network[key].lan_wan : [];
            if (this.newJson.network[key].lan_wan.indexOf(this.newJson.super_tcp.virt_if) == -1) {
                this.newJson.network[key].lan_wan.push(this.newJson.super_tcp.virt_if)
            }
            //this.newJson.network[key].lan_wan.push(this.newJson.super_tcp.virt_if);
          }
        })
      } else if (this.newJson.super_tcp?.instance) {
        let newJsonKeys = Object.keys(this.newJson);
        if (this.newJson.super_tcp.instance.indexOf("..") > -1) {
          this.newJson.super_tcp.instance = this.search_double_dot(
            this.newJson.super_tcp.instance
          );
        } else if (this.newJson.super_tcp.instance.indexOf(",") > -1) {
          this.newJson.super_tcp.instance =
            this.newJson.super_tcp.instance.split(",");
        }
        for (let i in this.newJson.super_tcp.instance) {
          //for (let k in newJsonKeys) {
          if (newJsonKeys.indexOf(this.newJson.super_tcp.instance[i]) > -1) {
            if (this.newJson[this.newJson.super_tcp.instance[i]].iface.indexOf("..") > -1
            ) {
              this.newJson[this.newJson.super_tcp.instance[i]].iface = this.search_double_dot(this.newJson[this.newJson.super_tcp.instance[i]].iface);
            } else if (
              this.newJson[this.newJson.super_tcp.instance[i]].iface.indexOf(",") > -1
            ) {
              this.newJson[this.newJson.super_tcp.instance[i]].iface = this.newJson[this.newJson.super_tcp.instance[i]].iface.split( ",");
            }
            /* let networkKeys = Object.keys(this.newJson.network);
            for (let key in networkKeys) {
              if (this.newJson[this.newJson.super_tcp.instance[i]].iface.indexOf(networkKeys[key]) > -1) {
                if (!this.selectedLanWanInterfaces[networkKeys[key]]) {
                  this.$set(this.selectedLanWanInterfaces, networkKeys[key], []
                  );
                }
                if (this.selectedLanWanInterfaces[networkKeys[key]].indexOf(this.newJson[this.newJson.super_tcp.instance[i]].virt_if) == -1) {
                  this.selectedLanWanInterfaces[networkKeys[key]].push(this.newJson[this.newJson.super_tcp.instance[i]].virt_if);
                }
              }
            } */
            Object.keys(this.newJson.network).forEach((network_index) => {
              if (this.newJson[this.newJson.super_tcp.instance[i]].iface.indexOf(network_index) > -1) {
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
                if (this.newJson.network[network_index].lan_wan.indexOf(this.newJson[this.newJson.super_tcp.instance[i]].virt_if) == -1) {
                  this.newJson.network[network_index].lan_wan.push(this.newJson[this.newJson.super_tcp.instance[i]].virt_if);
                }
              }
            })
          }
        }
      }
      //поиск уже выбранных WAN interfaces для LAN в режиме WAN в route_man
      if (this.newJson.route_man?.multi_iface) {
        if (this.newJson.route_man.multi_iface.indexOf("..") > -1) {
          this.newJson.route_man.multi_iface = this.search_double_dot(
            this.newJson.route_man.multi_iface
          );
        } else if (this.newJson.route_man.multi_iface.indexOf(",") > -1) {
          this.newJson.route_man.multi_iface =
            this.newJson.route_man.multi_iface.split(",");
        }
        Object.keys(this.newJson.network).forEach((key) => {
            if (this.newJson.route_man.multi_iface.indexOf(key) > -1) {
              /* this.selectedLanWanInterfaces[key] = this.selectedLanWanInterfaces[key] ? this.selectedLanWanInterfaces[key] : [];
              this.selectedLanWanInterfaces[key].push(this.newJson.route_man.tap); */
              this.newJson.network[key].lan_wan = this.newJson.network[key].lan_wan ? this.newJson.network[key].lan_wan : [];
              if (this.newJson.network[key].lan_wan.indexOf(this.newJson.route_man.tap) == -1) {
                this.newJson.network[key].lan_wan.push(this.newJson.route_man.tap)
              }
              //this.newJson.network[key].lan_wan.push(this.newJson.super_tcp.virt_if);
            }
          })

      } else if (this.newJson.route_man?.instance) {
        let newJsonKeys = Object.keys(this.newJson);
        if (this.newJson.route_man.instance.indexOf("..") > -1) {
          this.newJson.route_man.instance = this.search_double_dot(this.newJson.route_man.instance);
        } else if (this.newJson.route_man.instance.indexOf(",") > -1) {
          this.newJson.route_man.instance = this.newJson.route_man.instance.split(",");
        }
        for (let i in this.newJson.route_man.instance) {
          //for (let k in newJsonKeys) {
          if (newJsonKeys.indexOf(this.newJson.route_man.instance[i]) > -1) {
            if (this.newJson[this.newJson.route_man.instance[i]].multi_iface.indexOf("..") > -1) {
              this.newJson[this.newJson.route_man.instance[i]].multi_iface = this.search_double_dot(this.newJson[this.newJson.route_man.instance[i]].multi_iface);
            } else if (
              this.newJson[this.newJson.route_man.instance[i]].multi_iface.indexOf(",") > -1) {
              this.newJson[this.newJson.route_man.instance[i]].multi_iface = this.newJson[this.newJson.route_man.instance[i]].multi_iface.split(",");
            }
            /* let networkKeys = Object.keys(this.newJson.network);
            for (let key in networkKeys) {
              if (this.newJson[this.newJson.route_man.instance[i]].multi_iface.indexOf(networkKeys[key]) > -1) {
                if (!this.selectedLanWanInterfaces[networkKeys[key]]) {
                  this.$set(this.selectedLanWanInterfaces,networkKeys[key],[]);
                }
                if (this.selectedLanWanInterfaces[networkKeys[key]].indexOf(this.newJson[this.newJson.route_man.instance[i]].tap) == -1) {
                  this.selectedLanWanInterfaces[networkKeys[key]].push(this.newJson[this.newJson.route_man.instance[i]].tap);
                }
              }
            } */
             Object.keys(this.newJson.network).forEach((network_index) => {
              if (this.newJson[this.newJson.route_man.instance[i]].multi_iface.indexOf(network_index) > -1) {
                this.newJson.network[network_index].lan_wan = this.newJson.network[network_index].lan_wan ? this.newJson.network[network_index].lan_wan : [];
                if (this.newJson.network[network_index].lan_wan.indexOf(this.newJson[this.newJson.route_man.instance[i]].tap) == -1) {
                  this.newJson.network[network_index].lan_wan.push(this.newJson[this.newJson.route_man.instance[i]].tap);
                }
              }
            })
          }
        }
      }
      this.newJson.network = {...this.newJson.network}
      //console.log(this.newJson.network);
    },
    add_multi() {
      this.multi["multi_link_" + (this.cnt_mul + 1)] = "";
      this.multi = { ...this.multi };
    },
    save_config() {
      this.show = false;
      this.$http.api.saveConfigProfile(
        {
          id: this.dev_id,
          config: { main: this.main, multi_instance: this.multi },
        },
        (response) => {
          if (response.data.status) {
            this.global_notify("info", this.translate("config.saved_success"));
            this.main = response.data.config.main;
            this.multi = response.data.config.multi_instance;
            this.ver = response.data.ver;
            this.show = true;
            this.ts = new Date(response.data.ts * 1000);
          }
        }
      );
    },
  },
};
</script>

<style lang='scss' scoped>
.configuration {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  //overflow-y: scroll;
  .main_config {
    width: 100%;
    height: 100%;
    .btn:focus {
      outline: none;
    }
    .button_add {
      display: flex;
      margin-bottom: 20px;
      font-size: 13px;
    }
    &__wrap {
      height: 100%;
      .tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tab {
          width: 100%;
          padding: 5px 0;
          cursor: pointer;
          font-weight: 600;
          text-align: center;
          background: #efe9e9;
          border: 1px solid #efe9e9;
          transition: 0.3s;
          &.active {
            border-bottom: 1px solid white;
            background: white;
          }
          &.disabled {
            border: 1px solid #efe9e9;
            background: #eee;
          }
        }
      }
      .block {
        border: 1px solid #ffffff00;
        height: calc(100% - 80px);
        margin-top: -1px;
        padding: 15px;
        .add_lan {
          width: fit-content;
        }
        .page {
          display: flex;
          flex-wrap: wrap;
        }
      }
      .button {
        height: 53px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .btn {
          width: 160px;
          height: 40px;
        }
      }
    }
    textarea {
      flex: 10;
      width: 100%;
      overflow: auto;
      font-size: 16px;
      line-height: 125%;
    }
  }
  .save_config {
    margin-top: 10px;
  }
}
</style>
